import { LinearProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { Panel } from "@poseidon/ui/components";
import ErrorBoundary from "@poseidon/ui/components/ErrorBoundary";
import NoteLog from "./NoteLog";
import { useNotesLog } from "./useNotesLog";

export function NoteLogPanel({ title, dbPathSlugs, updateHandler, mapper }) {
  const { notesLog, loading, error } = useNotesLog(dbPathSlugs, mapper);
  const { setError } = useErrorMessage();

  if (error) {
    setError(error);
  }

  if (loading || !notesLog) {
    return <LinearProgress />;
  }

  return (
    <Panel
      title={title}
      collapsedDetail={`${notesLog.length} notes`}
      expandable
      startCollapsed
    >
      <NoteLog log={notesLog} onSubmitHandler={updateHandler} />
    </Panel>
  );
}

const ErrorCaughtNoteLogPanel = (props) => (
  <ErrorBoundary>
    <NoteLogPanel {...props}></NoteLogPanel>
  </ErrorBoundary>
);
export default ErrorCaughtNoteLogPanel;
